import BaseStartFlowAction from "@/action/actions/BaseStartFlowAction"
import ActionId from "@/action/ActionId"
import { scrubEntityKey } from "@/util/entity"
import { flowService } from "@/service"
import {providerState} from "@/state";

class StartFlowAction extends BaseStartFlowAction {

    constructor(route) {
        super(ActionId.START_FLOW, route)
    }

    async callStartFlowService() {
        const token = this.route.params.token
        const entityKey = this.route.params.entityKey

        const startRequest = {
            testCaseId: this.route.query.testCaseId,
        }

        let response

        if (token) {
            response = await flowService.startFlowWithToken(token)
        } else if (entityKey) {
            response = await flowService.startFlowWithEntityKey(scrubEntityKey(entityKey), startRequest)
        } else {
            response = await flowService.startFlowWithDefaultEntityKey(startRequest)
        }

        response.providerConfigs.forEach(config => {
            providerState.setProviderProperties(config.providerKey, config.properties)
        })

        return response
    }
}

export default StartFlowAction
